(function () {
  'use strict';

  function initTxtImg(section) {
    const animElements = section.querySelectorAll('.wb-anim-entry');

    if (animElements.length > 0) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view'); 
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      animElements.forEach(el => observer.observe(el));
    }
  }

  function init() {
    document.querySelectorAll('.wb-txtimg').forEach(initTxtImg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('wb-txtimg') || event.target.querySelector('.wb-txtimg')) {
      initTxtImg(event.target.classList.contains('wb-txtimg') ? event.target : event.target.querySelector('.wb-txtimg'));
    }
  });

})();